import baustein from "baustein";
import store from "web/redux/store";
import { openSignupOverlay } from "web/redux/ducks/signup-overlay";

const S4L_SIGNUP_PROMPT_SELECTOR = ".app-header-bar__s4l-signup";

export default baustein.register("app-header-bar", {
    setupEvents(add) {
        add("click", S4L_SIGNUP_PROMPT_SELECTOR, this._onAnonymousSaveForLater);
    },

    /**
     * Handler for click events on save for later icon
     */
    _onAnonymousSaveForLater() {
        // send it up to the lyst-app to open
        const signupOverlayOptions = {
            path: "/account/register/",
            queryParams: {
                next: [window.location.pathname + window.location.search],
                type: ["save_for_later"],
            },
            formType: "save_for_later_signup",
            pageType: "save_for_later",
            pageSubType: "signup_or_login",
        };

        store.dispatch(openSignupOverlay(signupOverlayOptions));
    },
});
